import { COLORS } from '@btime/constants'
import { useNotification } from '@btime/react-messager'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { genPdfUrl, genPublicResumeUrl } from '../../../../utils/helpers/serviceOrder'
import FlexGrid, { FlexCol } from '../../../../components/structure/FlexGrid'
import Icon from '../../../../components/shapes/Icon'
import Link from '../../../../components/actions/Link'

// 2.75rem ≈ 44px — minimum recommended touch target, since this public history page
// is opened mostly from smartphones after scanning a QR code.
const TOUCH_TARGET_STYLE = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: '2.75rem',
  minHeight: '2.75rem'
}

const copyToClipboard = async text => {
  try {
    if (navigator?.clipboard?.writeText) {
      await navigator.clipboard.writeText(text)
      return true
    }
  } catch (error) {
    // falls back to the legacy execCommand path below (older mobile browsers / non-HTTPS)
  }

  const input = document.createElement('input')
  input.value = text
  input.style.position = 'fixed'
  input.style.opacity = '0'
  document.body.appendChild(input)
  input.focus()
  input.select()
  input.setSelectionRange(0, 99999)
  const copied = document.execCommand('copy')
  document.body.removeChild(input)
  return copied
}

const TouchAction = ({ onClick, title, iconName }) => (
  <Link onClick={onClick} title={title} aria-label={title}>
    <span style={TOUCH_TARGET_STYLE}>
      <Icon name={iconName} size="1.4rem" color={COLORS.purple} />
    </span>
  </Link>
)

const PublicHistoryRowActions = ({ serviceOrder }) => {
  const { t } = useTranslation('listServiceOrdersHistory')
  const notify = useNotification()

  const pdfUrl = genPdfUrl(serviceOrder)
  const resumeUrl = genPublicResumeUrl(serviceOrder)

  // Only activities that expose a public resume/report (i.e. the ones the backend
  // makes available in the QR code history) show these quick actions.
  if (!pdfUrl && !resumeUrl) return null

  const openPdf = event => {
    if (event) event.stopPropagation()
    window.open(pdfUrl, '_blank', 'noopener,noreferrer')
  }

  const copyLink = async event => {
    if (event) event.stopPropagation()
    const copied = await copyToClipboard(resumeUrl)
    if (copied) notify.success({ title: t('actions.linkCopied') })
    else notify.error({ title: t('actions.linkCopyError') })
  }

  return (
    <FlexGrid justify="flex-end" align="center" gutter={0.2}>
      {!!pdfUrl && (
        <FlexCol>
          <TouchAction onClick={openPdf} title={t('actions.viewPdf')} iconName="BsFileRichtext" />
        </FlexCol>
      )}

      {!!resumeUrl && (
        <FlexCol>
          <TouchAction onClick={copyLink} title={t('actions.copyLink')} iconName="BsLink45Deg" />
        </FlexCol>
      )}
    </FlexGrid>
  )
}

export default PublicHistoryRowActions
